import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Accordion from '../components/Accordion/Accordion';
import { useMediaQuery } from 'react-responsive';
import { DataContext } from '../contexts/DataContext';

function HistoryPage() {
  const { t } = useTranslation();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const { type } = useParams();
  const { data } = useContext(DataContext);

  const cleaningData = data.MaintenanceInfo.cleaning || [];
  const repairData = data.MaintenanceInfo.repair || [];

  const hasValidCleaning = cleaningData.some(item => item?.date);
  const hasValidRepair = repairData.some(item => item?.date);

  const renderAccordionOrMessage = (title, iconSrc, items, type, hasValidItems) => {
    return hasValidItems ? (
      <Accordion title={title} iconSrc={iconSrc} items={items} type={type} />
    ) : (
      <div className="accordion-empty">
        <div className="section-title">
          <span className="icon">
            <img src={iconSrc} alt={title} width="20" height="20" />
          </span>
          <span className="title-text">{title}</span>
        </div>
        <div className="maintenance-empty">{t('historyPage.noHistory', { title })}</div>
      </div>
    );
  };

  return (
    <>
      {isMobile ? (
        <div className="box-left">
          {type === 'cleaning' &&
            renderAccordionOrMessage(t('historyPage.cleaningTitle'), '/images/icon/icon_cleaning.svg', cleaningData, 'cleaning', hasValidCleaning)}
          {type === 'repair' &&
            renderAccordionOrMessage(t('historyPage.repairTitle'), '/images/icon/icon_repair.svg', repairData, 'repair', hasValidRepair)}
        </div>
      ) : (
        <>
          <div className="box-left">
            {renderAccordionOrMessage(t('historyPage.cleaningTitle'), '/images/icon/icon_cleaning.svg', cleaningData, 'cleaning', hasValidCleaning)}
          </div>
          <div className="box-right">
            {renderAccordionOrMessage(t('historyPage.repairTitle'), '/images/icon/icon_repair.svg', repairData, 'repair', hasValidRepair)}
          </div>
        </>
      )}
    </>
  );
}

export default HistoryPage;
